// extracted by mini-css-extract-plugin
export const content = "Content-module--content--3dNJJ";
export const content__date = "Content-module--content__date--34oai";
export const content__toc = "Content-module--content__toc--2aioO";
export const content__divider = "Content-module--content__divider--3eGhO";
export const content__title = "Content-module--content__title--2bVSe";
export const content__body = "Content-module--content__body--1YAIr";